import { cn } from '@/lib/utils';
import { Search } from '@/icons/Icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useCommandPaletteStore } from '@/lib/stores/command-palette';
import { commandPaletteShortcutHint } from '@/features/command-palette/command-palette-platform';

/**
 * Opens the command palette (⌘K / Ctrl+K). Sits below the brand row, above
 * the workspace card — works identically expanded or collapsed to the icon
 * rail; collapsed shows just the icon with the shortcut in its tooltip,
 * matching every other collapsed sidebar control (`SidebarItem`,
 * `SidebarWorkspaceCard`'s connect button).
 */
export function SidebarSearchTrigger({ collapsed }: { collapsed: boolean }) {
  const open = useCommandPaletteStore((s) => s.open);
  const hint = commandPaletteShortcutHint();

  const button = (
    <button
      type="button"
      onClick={open}
      aria-label={collapsed ? `Search (${hint})` : 'Search'}
      className={cn('sidebar-search-trigger', collapsed && 'is-collapsed')}
    >
      <Search size={collapsed ? 15 : 14} aria-hidden />
      {!collapsed && (
        <>
          <span className="sidebar-search-trigger-label">Search</span>
          <span className="sidebar-search-trigger-hint" aria-hidden>
            {hint}
          </span>
        </>
      )}
    </button>
  );

  return (
    <div className="sidebar-search-wrap">
      {collapsed ? (
        <Tooltip>
          <TooltipTrigger asChild>{button}</TooltipTrigger>
          <TooltipContent side="right" sideOffset={10}>
            {`Search · ${hint}`}
          </TooltipContent>
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
}
